import { render, staticRenderFns } from "./DynamicValueSwitch.vue?vue&type=template&id=9f4d695a"
import script from "./DynamicValueSwitch.vue?vue&type=script&lang=js"
export * from "./DynamicValueSwitch.vue?vue&type=script&lang=js"
import style0 from "./DynamicValueSwitch.vue?vue&type=style&index=0&id=9f4d695a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports